import styled from 'styled-components';
import "@fontsource/roboto-flex";
import { MediaQuery, Size } from '../../constant/breakpoint.ts';

export const FirstBox = styled('div')({
    width: "35%",
    [MediaQuery[Size.LG]]: {
        width: "100%",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "12px"
    },
})

export const Title = styled('div')({
    fontSize: "50px",
    fontWeight: "425",
    color: "#CCA25E",
    width: "300px",
    fontFamily: "Gotham",
    
    [MediaQuery[Size.XL]]: {
        width: "100%",
        fontSize: "32px",
    },
    [MediaQuery[Size.MD]]: {
        width: "100%",
        fontSize: "40px",
    },

    [MediaQuery[Size.SM]]: {
        width: "100%",
        fontSize: "32px",
    },
})

export const ImgArrow = styled('img')({
    [MediaQuery[Size.MD]]: {
        width: "100%",
        fontSize: "32px",
    },
})

export const Subtitle = styled('div')({
    fontSize: "36px",
    fontWeight: "400",
    color: "black",
    [MediaQuery[Size.XL]]: {
        width: "100%",
        fontSize: "20px",
    },
    [MediaQuery[Size.MD]]: {
        fontSize: "24px",
    },  
})

export const NewsTitle = styled('div')({
    fontFamily: 'Roboto Flex',
    fontSize: '30px',
    fontWeight: '600'

})

export const Newsmonth = styled('div')({
    fontFamily: 'Roboto Flex',
    fontSize: '12px',
    fontWeight: '700',
    color: '#CCA25E',
    marginTop: '2px'
})

export const NewsDescription = styled('div')({
    fontFamily: 'Roboto Flex',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '16px',
    color: '#201F1F',
    marginTop: '16px'
})

export const ReadMoreButton = styled('div')({
    color: "#CCA25E",
    fontFamily: 'Roboto Flex',
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: '12px',
    float: "right",
    marginTop: "10px",
    display: "flex",
    justifyContent: 'center',
    alignItems: 'center'
})

export const Circle = styled('div')({
    height: "30px",
    width: "30px",
    backgroundColor: "#CCA25E",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "8px"
})

export const Arrow = styled('img')({
    width: "16px",
    height: "16px"
})

export const ArticleContainer = styled('div')({
    marginLeft: '100px',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [MediaQuery[Size.XXL]]: {
        marginLeft: '60px',
    },
    [MediaQuery[Size.XL]]: {
        marginLeft: '40px',
    },
    [MediaQuery[Size.MD]]: {
        flexDirection: 'column',
        marginLeft: '0px',
        alignItems: "center",
        justifyContent: "center",
        rowGap: "40px"
    },
})

export const StayInformedContainer = styled('div')({
    display: 'flex',
    marginTop:'60px',
    marginBottom:'60px',
    marginLeft:'60px',
    marginRight:'60px',
    flexDirection:'row',
    alignItems:'center',

    [MediaQuery[Size.XL]]: {
        marginTop:'52px',
        marginBottom:'52px',
        marginLeft:'52px',
        marginRight:'52px',
    },

    [MediaQuery[Size.LG]]: {
        flexDirection: 'column',
        marginTop:'40px',
        marginBottom:'40px',
        marginLeft:'40px',
        marginRight:'40px',
    },
})
